import { useEffect, useRef, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setEmployeeData, updateEmployee } from "./employeeSlice";

function validEmail(email) {
  const isValidEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
    email || "",
  );
  return isValidEmail;
}
function validPhone(x) {
  const out = /^[0-9]+$/.test(x || "");
  return out;
}

const useEditPersonalInformation = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const toastRef = useRef(null);
  const location = useLocation();
  const activeTab = location.pathname.split("/")[3] || "info";
  const { employeeDetails, isEdit, personalInformation, isDataAvailable } =
    useSelector((state) => state.employeeregister);
  const [geninfo, setGeninfo] = useState();
  const [isSaveBtn, setIsSaveBtn] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [reset, setReset] = useState(false);
  const [isAuditSidebarVisible, setAuditSidebarVisible] = useState(false);

  useEffect(() => {
    dispatch(setEmployeeData({ key: "isEdit", value: false }));
  }, []);

  const initialdata = () => {
    let obj = {
      given_name: employeeDetails?.name,
      other_name: employeeDetails?.other_name,
      last_name: employeeDetails?.last_name,
      preferred_name: employeeDetails?.preferred_name,
      tax_identification_no: employeeDetails?.tax_id_number,
      national_id: employeeDetails?.national_id,
      social_security_number: employeeDetails?.ssn,
      personal_email: employeeDetails?.personal_email,
      work_email: employeeDetails?.work_email,
      phone_code: employeeDetails?.phone_number.split("-")[0],
      phone: employeeDetails?.phone_number.split("-")[1],
      marital_status: employeeDetails?.marital_status,
    };
    return obj;
  };

  useEffect(() => {
    const obj = initialdata();
    setGeninfo(obj);
    dispatch(
      setEmployeeData({
        key: "personalInformation",
        value: obj,
      }),
    );
  }, [employeeDetails]);

  const handleEnableEdit = () => {
    setReset(false);
    setIsUpdating(false);
    setIsSaveBtn(true);
    dispatch(
      setEmployeeData({
        key: "isEdit",
        value: true,
      }),
    );
  };

  const handleDiscardEdit = () => {
    setReset(true);
    setIsSaveBtn(false);
    const obj = initialdata();
    dispatch(
      setEmployeeData({
        key: "isEdit",
        value: false,
      }),
    );
    setGeninfo(obj);
    dispatch(
      setEmployeeData({
        key: "personalInformation",
        value: obj,
      }),
    );
  };

  const handleChange = (name, value) => {
    setGeninfo((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleUpdatePersonalInformation = () => {
    let data = {
      name: geninfo?.given_name || "",
      other_name: geninfo?.other_name || "",
      last_name: geninfo?.last_name || "",
      preferred_name: geninfo?.preferred_name || "",
      tax_id_number: geninfo?.tax_identification_no || "",
      national_id: geninfo?.national_id || "",
      ssn: geninfo?.social_security_number || "",
      ...(geninfo?.marital_status &&
        geninfo?.marital_status.trim() !== "" && {
          marital_status: geninfo?.marital_status,
        }),
      personal_email: geninfo?.personal_email || "",
      work_email: geninfo?.work_email || "",
      phone_number: `${geninfo?.phone_code}-${geninfo?.phone}` || "",
    };
    setIsUpdating(true);
    dispatch(setEmployeeData({ key: "isUpdating", value: true }));
    dispatch(
      updateEmployee({ id: id, data: { ...employeeDetails, ...data } }),
    ).then(() => {
      toastRef.current.show({
        severity: "success",
        summary: "Personal information",
        detail: "has been updated!",
        icon: "pi pi-check",
      });
      dispatch(setEmployeeData({ key: "isEdit", value: false }));
      dispatch(setEmployeeData({ key: "isUpdating", value: false }));
      dispatch(
        setEmployeeData({
          key: "employeeDetails",
          value: { ...employeeDetails, ...data },
        }),
      );
      setIsUpdating(false);
    });
  };

  useEffect(() => {
    const areObjectsEqual = (obj1 = {}, obj2 = {}) => {
      if (Object.keys(obj1).length !== Object.keys(obj2).length) {
        return false;
      }

      return Object.keys(obj1).every((key) => obj1[key] === obj2[key]);
    };
    const isIdentical = areObjectsEqual(geninfo, personalInformation);
    const isInfoValid =
      geninfo?.given_name &&
      geninfo?.last_name &&
      geninfo?.personal_email &&
      validEmail(geninfo?.personal_email) &&
      geninfo?.phone &&
      validPhone(geninfo?.phone) &&
      geninfo?.phone_code &&
      validPhone(geninfo?.phone_code) &&
      geninfo?.work_email &&
      validEmail(geninfo?.work_email);

    setIsSaveBtn(!isInfoValid || isIdentical);
  }, [personalInformation, geninfo]);

  return {
    employeeDetails,
    handleEnableEdit,
    handleDiscardEdit,
    handleChange,
    reset,
    handleUpdatePersonalInformation,
    setAuditSidebarVisible,
    toastRef,
    genstate: {
      isDataAvailable,
      activeTab,
      isEdit,
      geninfo,
      isSaveBtn,
      isUpdating,
      isAuditSidebarVisible,
    },
  };
};

export default useEditPersonalInformation;
